import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNews = () => {
  return (
    <g>
      <path d="m2.4427 15.1711.6325.003h10.4922a2.3733 2.3733 0 0 0 2.3706-2.3706v-11.2276a.75.75 0 0 0 -.75-.75h-11.1543a.75.75 0 0 0 -.75.75v2.8872h-2.4717a.75.75 0 0 0 -.75.75v7.59a2.3711 2.3711 0 0 0 2.3315 2.3669c.0069 0 .0126.004.02.004l.01-.0009.0092.0009.0156-.0031m-.0253-1.4988a.8706.8706 0 0 1 -.8608-.8687v-6.84h1.7215v6.84a.8706.8706 0 0 1 -.8609.8687zm2.3607-11.3462h9.6543v10.4776a.8717.8717 0 0 1 -.8706.8706h-8.9492a2.3564 2.3564 0 0 0 .1655-.8706z" />
      <path d="m6.9346 8.6965h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z" />
      <path d="m6.9346 11.7234h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z" />
      <path d="m6.9346 5.7068h5.4009a.75.75 0 0 0 0-1.5h-5.4009a.75.75 0 0 0 0 1.5z" />
    </g>
  );
};

export default withIcon(IconNews);
